__turbopack_context__.v({
  "className": "shyest_c8a237eb-module__h4ImVW__className",
  "variable": "shyest_c8a237eb-module__h4ImVW__variable",
});
